import React, { useEffect, useState } from "react";
import Dashboard from "../Dashboard";
import CouponsList from "../../../features/adminDashboard/Coupons/CouponList/CouponsList";
import CreateCoupon from "../../../features/adminDashboard/Coupons/CreateCoupon/CreateCoupon";

function Coupons() {
  const [activeTab, setActiveTab] = useState("list");
  return (
    <Dashboard>
      <div className="w-full h-full px-4 pb-8">
        {/* Tab Navigation */}
        <div className="flex space-x-1 bg-gray-100 p-1 rounded-lg mb-6">
          <button
            onClick={() => setActiveTab("list")}
            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
              activeTab === "list"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            List Coupons
          </button>
          <button
            onClick={() => setActiveTab("create")}
            className={`flex-1 py-2 px-4 rounded-md text-sm font-medium transition-colors ${
              activeTab === "create"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-600 hover:text-gray-900"
            }`}
          >
            Create Coupon
          </button>
        </div>
      </div>

      {activeTab === "list" && <CouponsList onSetActiveTab={setActiveTab} />}
      {activeTab === "create" && <CreateCoupon onSetActiveTab={setActiveTab} />}
    </Dashboard>
  );
}

export default Coupons;
